<template>
  <div>
    <div class="display-flex">
      <bh-button
        btnClass="w15 br0-5 f1-5 ml0-5-mb"
        :class="customDateSet ? 'bg-violet text-white border-none pa0-6' : 'bg-white text-violet border-violet pa0-5'"
        @output="openDateTimePicker"
      >
        Custom
      </bh-button>

      <bh-button v-if="customDateSet && !isInvalidCustomDate" btnClass="w15 w40p-mb bg-white text-violet border-violet br0-5 f1-5 pa0-6 ml2 ml0-5-mb" @output="resetVitals">
        Reset
      </bh-button>
    </div>

    <bh-modal-overlay :showModal="showModal" @modal-close="closeModal">
      <div class="datetimepicker-container bg-white pv1 ph2 flex-column br1">
        <v-date-picker
          class="f2"
          width="350"
          v-model="datePicker"
          :show-current="selectedDate"
          header-color="primary"
          no-title
          :min="moment.formatDate(dateRange.minDate * 1000, 'YYYY-MM-DD')"
          :max="moment.formatDate(dateRange.maxDate * 1000, 'YYYY-MM-DD')"
        ></v-date-picker>
        <div
          class="time-picker display-flex justify-around align-center pv3 ph1"
        >
          <span class="f1-5">Time: </span>
          <div class="hrs-container border-grey ml1 br0-8">
            <input
              class="w5 f1-5 ph1 pv0-3 border-right-grey outline-none"
              maxlength="12"
              minlength="1"
              type="number"
              v-model="selectedHour"
              required
              @keyup="onTimeChange"
            />
            <span class="f1 pa1">hrs</span>
          </div>
          <div class="hrs-container border-grey ml1 br0-8">
            <input
              class="w5 f1-5 ph1 pv0-3 border-right-grey outline-none"
              maxlength="12"
              minlength="1"
              type="number"
              v-model="selectedMinute"
              required
              @keyup="onTimeChange"
            />
            <span class="f1 pa1">mins</span>
          </div>
          <div class="ml1">
            <bh-select
              placeholder="Select"
              class="br0-8 border-grey pointer"
              classes="z-999999"
              autocomplete="off"
              :value="selectedTimePeriod"
              :options="timePeriodList"
              @output="updateSelectedTimePeriod"
            />
          </div>
        </div>
        <div class="text-danger pt1" v-if="isInvalidDateTime">Please provide a valid time</div>
        <div class="display-flex justify-end align-center mt5 mb2">
          <span
            class="underline text-violet f1-5 mr5 pointer"
            @click="closeModal"
            >Cancel</span
          >
          <bh-button
            btnClass="w20p bg-violet text-white border-none br0-5 f1-5 pa1 mr1"
            @output="pickDateAndTime()"
            :disabled="isInvalidDateTime || !datePicker"
            >Done</bh-button
          >
        </div>
      </div>
    </bh-modal-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from '@/utils/moment'

export default {
  name: 'bh-date-time-picker',
  props: {
    isInvalidCustomDate: false,
    dateRange: {}
  },
  data() {
    return {
      showModal: false,
      datePicker: this.selectedDate,
      selectedHour: (new Date().getHours() % 12).toString().padStart(2, 0),
      selectedMinute: new Date().getMinutes().toString().padStart(2, 0),
      selectedTimePeriod: new Date().getHours() > 12 ? 'P.M.' : 'A.M.',
      timePeriodList: [
        {
          label: 'A.M.',
          value: 'A.M.'
        },
        {
          label: 'P.M.',
          value: 'P.M.'
        }
      ],
      isInvalidDateTime: false,
      moment: moment
    }
  },
  computed: {
    ...mapGetters('device', ['customDateSet']),
    ...mapGetters('common/dateTimePicker', ['selectedDate'])
  },
  methods: {
    ...mapActions('common/dateTimePicker', ['setDate']),
    onTimeChange(e) {
      const isValidHour = this.selectedHour && this.selectedHour > 0 && this.selectedHour <= 12
      const isValidMinute = this.selectedMinute && this.selectedMinute > -1 && this.selectedMinute < 60
      this.isInvalidDateTime = !isValidHour || !isValidMinute
    },
    updateSelectedTimePeriod(selectedPeriod) {
      if (selectedPeriod) {
        this.selectedTimePeriod = selectedPeriod
      }
    },
    pickDateAndTime() {
      this.selectedHour = this.selectedHour.substr(this.selectedHour.length - 2, this.selectedHour.length)
      this.selectedHour = this.selectedTimePeriod === 'A.M.' && this.selectedHour === '12' ? '00' : this.selectedHour
      this.selectedHour = this.selectedTimePeriod === 'P.M.' ? parseInt(this.selectedHour) + 12 : this.selectedHour.toString().padStart(2, 0)

      const selectedDate = `${this.datePicker} ${this.selectedHour}:${this.selectedMinute.toString().padStart(2, 0)}:${new Date().getSeconds()}`

      this.setDate(selectedDate.substr(0, 10))
      this.$emit('pickDateAndTime', selectedDate)
      this.closeModal()
    },
    openDateTimePicker() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.selectedHour = (new Date().getHours() % 12).toString().padStart(2, 0)
      this.selectedMinute = new Date().getMinutes().toString().padStart(2, 0)
      this.isInvalidDateTime = false
      this.$emit('closeDateTime', this.showModal)
    },
    resetVitals() {
      this.$emit('onResetVitals', true)
      this.setDate(new Date().toISOString().substr(0, 10))
    }
  }
}
</script>

<style scoped>
.v-picker.v-card.v-picker--date.theme--light {
  box-shadow: none;
}

.time-picker {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

ul.dropdown-menu {
  box-shadow: none;
}

.datetimepicker-container .v-date-picker-table {
  padding: 0;
}

.v-date-picker-header__value {
  font-size: 3rem;
}
</style>
